export default __webpack_public_path__ + "static/media/bg_mobile_funky.84046555.svg";